<template>
  <div class="self-center mx-3">
    <p class="text-2xl font-bold">{{ title }}</p>
  </div>
<!--    <vs-navbar class="flex flex-col sm:flex-row" type="shadow">-->
<!--      <div class="whitespace-pre" slot="title">-->
<!--        <vs-navbar-title class="font-bold">-->
<!--          {{ title}}-->
<!--        </vs-navbar-title>-->
<!--      </div>-->
<!--    </vs-navbar>-->
</template>

<script>
  export default {
    props: ['title'],
  }
</script>

<style scoped>

</style>
